
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/[...slug]",
      function () {
        return require("private-next-pages/support/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/[...slug]"])
      });
    }
  